import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  DialogTitle,
  Paper,
  Card,
  CardContent,
  TextField
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { salesApi, investorApi } from '../../api/api';

const SalePage = () => {
  const [legalTeam, setLegalTeam] = useState([]);
  const [saleData, setSaleData] = useState([]);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedTeamMember, setSelectedTeamMember] = useState("");
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 5,
    page: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const response = await salesApi.getSales();
        const data = response.data;
        const statusOrder = {
          'Initiated': 1,
          'InProgress': 2,
          'Completed': 3,
          'Rejected': 4,
        };

        const sortedData = data.sort((a, b) =>
          (statusOrder[a.Status] || 99) - (statusOrder[b.Status] || 99)
        );

        setSaleData(sortedData);
      } catch (error) {
        console.error('Failed to fetch sales data:', error);
      }
    };

    const getLegalTeam = async () => {
      try {
        const response = await investorApi.getLegalTeam();
        setLegalTeam(response.data);
      } catch (error) {
        console.error("Error fetching legal team:", error);
      }
    };

    getLegalTeam();
    fetchSales();
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case 'Initiated': return 'blue';
      case 'Completed': return 'green';
      case 'InProgress': return 'orange';
      case 'Rejected': return 'red';
      default: return 'grey';
    }
  };

  const assignLegalTeam = async () => {
    if (!selectedProperty || !selectedTeamMember) return;

    try {
      const response = await investorApi.addSaleToLegalTeam({
        propertyId: selectedProperty.propertyId,
        userId: selectedTeamMember,
        PropertyType: selectedProperty.PropertyType,
        // Mobilenumber: selectedProperty.Mobilenumber
      });
      alert("Assigned successfully!");
      closeAssignModal();
    } catch (error) {
      console.error("Error assigning legal team:", error);
      alert("Assignment failed.");
    }
  };

  const openAssignModal = (row) => {
    setSelectedProperty(row);
    setSelectedTeamMember("");
    setAssignModalOpen(true);
  };

  const closeAssignModal = () => {
    setAssignModalOpen(false);
    setSelectedProperty(null);
  };
  const renderCellWithFallback = (params) => {
    return params.value === null || params.value === undefined || params.value === ''
      ? '------'
      : params.value;
  };




  const columns = [
    {
      field: 'serialNo',
      headerName: 'ID',
      width: 90,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1
    }
    ,
    { field: 'UserName', headerName: 'User Name', width: 150 },
    {
      field: 'Mobilenumber',
      headerName: 'Mobile Number',
      width: 200,
      renderCell: params => (
        <Typography sx={{ color: '#0871c5' }}>
          {params.value}
        </Typography>
      ),
    },
    { field: 'PropertyType', headerName: 'Property Type', width: 150 },
    { field: 'project_name', headerName: 'Project Name', width: 200, renderCell: renderCellWithFallback },
    { field: 'ApartmentName', headerName: 'Apartment Name', width: 200, renderCell: renderCellWithFallback },
    { field: 'PropertyName', headerName: 'Property Name', width: 200 },
    { field: 'City', headerName: 'City', width: 150 },
    { field: 'AdvancePayment', headerName: 'Advance Amount', width: 150 },
    { field: 'Price', headerName: 'Price', width: 150, renderCell: renderCellWithFallback },
    {
      field: 'Status',
      headerName: 'Status',
      width: 150,
      renderCell: (params) => (
        <span style={{
          color: getStatusColor(params.value),
          fontWeight: 'bold',
          textTransform: 'capitalize',
        }}>{params.value}</span>
      )
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 200,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box display="flex" gap={1}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => openAssignModal(params.row)}
          >
            Assign
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="secondary"
            onClick={() => navigate('/investor/updateSale', { state: { rowData: params.row } })}
          >
            Update
          </Button>
        </Box>
      )
    }
  ];


  return (
    <Box sx={{ mt: 2, height: "100%" }}>
      <Box sx={{ borderRadius: 4 }}>
        <Typography variant="h5" sx={{ mb: 2, color: '#13216e' }}>
          Sold Properties
        </Typography>

        <Card sx={{ mb: 2 }}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label="Search by keyword"
                  fullWidth
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    label="Status"
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="Initiated">Initiated</MenuItem>
                    <MenuItem value="InProgress">In Progress</MenuItem>
                    <MenuItem value="Completed">Completed</MenuItem>
                    <MenuItem value="Rejected">Rejected</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

            </Grid>
          </CardContent>
        </Card>

        <Card sx={{ height: "80vh" }}> {/* adjust vh as needed */}
          <Box sx={{ height: "100%" }}>
            <DataGrid
              rows={saleData
                .filter((row) =>
                  Object.values(row).some(
                    (val) =>
                      val &&
                      val.toString().toLowerCase().includes(searchQuery.toLowerCase())
                  )
                )
                .filter((row) => !statusFilter || row.Status === statusFilter)}
              columns={columns}
              getRowId={(row) => row.SaleId}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              pageSizeOptions={[5, 10, 25]}
              disableSelectionOnClick
              sx={{
                height: 650,
                border: '1px solid #ccc',
                borderRadius: 2,
                fontSize: '0.9rem',
                backgroundColor: '#ffffff',
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#f0f0f0ff',
                },
                '& .MuiDataGrid-cell': {
                  color: '#333',
                  borderBottom: '1px solid #ddd',
                },
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#f0f0f0ff',
                  color: 'black',
                  fontWeight: 'bold',
                },
                '& .MuiTablePagination-root': {
                  fontSize: '0.875rem',
                },
              }}
            />
          </Box>
        </Card>

      </Box>

      <Dialog open={assignModalOpen} onClose={closeAssignModal}
        PaperProps={{
          sx: { borderRadius: 3, p: 3, width: "50%", maxWidth: '90%' }
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.25rem', mb: 1 }}>
          Assign <span style={{ color: '#1976d2' }}>{selectedProperty?.PropertyName}</span> for Sale Update
        </DialogTitle>

        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>Select Legal Team Member</strong>
          </Typography>

          <FormControl fullWidth sx={{ mt: 1 }}>
            <InputLabel>Legal Team Member</InputLabel>
            <Select
              value={selectedTeamMember}
              onChange={(e) => setSelectedTeamMember(e.target.value)}
              label="Legal Team Member"
              sx={{ borderRadius: 2 }}
            >
              {Array.isArray(legalTeam) &&
                legalTeam.map((member) => (
                  <MenuItem key={member.id} value={member.id}>
                    {member.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions sx={{ mt: 2, justifyContent: 'flex-end' }}>
          <Button onClick={closeAssignModal} sx={{ color: '#666' }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={assignLegalTeam}
            disabled={!selectedTeamMember}
            sx={{ backgroundColor: '#1976d2', ':hover': { backgroundColor: '#115293' } }}
          >
            Assign
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SalePage;
